import { axios } from '@/utils/request'
// 上传sku文件Excel
export function uploadSKUTable(data) {
  return axios({
    url: '/distribution/productThirdItem',
    method: 'POST',
    data,
    headers: { 'Content-Type': 'multipart/form-data' }
  })
}
// 获取上传后的excel文件
export function getProductThirdItem(params) {
  return axios({
    url: '/distribution/productThirdItem',
    method: 'GET',
    params: params
  })
}
// 获取系统color
export function getColorsInSysterm() {
  return axios({
    url: '/api/stockColor',
    method: 'GET'
  })
}
// 获取系统size
export function getSizesInSysterm() {
  return axios({
    url: '/api/stockSize',
    method: 'GET'
  })
}
// 编辑单行
export function editProductThirdItem(data) {
  return axios({
    url: '/distribution/productThirdItem/' + data.id,
    method: 'PUT',
    data
  })
}
// 保存合并sku
export function saveGruopDesignApi(data) {
  return axios({
    url: '/distribution/batchDesign/change',
    method: 'POST',
    data
  })
}
